var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiggyBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 94 86",
    style: {
      enableBackground: "new 0 0 94 86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#58FDD9;}\n\t.st1{fill:#FCFCFC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ambassador"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambassador---Desktop",
    transform: "translate(-1008.000000, -1756.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1008.000000, 1756.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "st0",
    cx: 30.6,
    cy: 23.8,
    rx: 16.1,
    ry: 15.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M69.2,38.1c-2.7,0-4.8,2.1-4.8,4.8c0,2.7,2.1,4.8,4.8,4.8c2.7,0,4.8-2.1,4.8-4.8 C74,40.2,71.9,38.1,69.2,38.1z M69.2,44.4c-1,0-1.6-0.6-1.6-1.6c0-1,0.6-1.6,1.6-1.6c1,0,1.6,0.6,1.6,1.6 C70.8,43.8,70.2,44.4,69.2,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M46.7,76.2c-16.6,0-30.6-11-30.6-23.8c0-1-0.6-1.6-1.6-1.6s-1.6,0.6-1.6,1.6 c0,14.6,15.4,27,33.8,27c1,0,1.6-0.6,1.6-1.6S47.6,76.2,46.7,76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000132809146143549219390000010019403740212000699_",
    className: "st1",
    d: "M30.6,34.9c9.8,0,17.7-7.8,17.7-17.5 S40.4,0,30.6,0S12.9,7.8,12.9,17.5S20.8,34.9,30.6,34.9z M30.6,3.2c8,0,14.5,6.3,14.5,14.3s-6.4,14.3-14.5,14.3 s-14.5-6.3-14.5-14.3S22.5,3.2,30.6,3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000068637074177722591700000001893452105296176060_",
    className: "st1",
    d: "M88.5,44.4h-1.6c-0.6,0-1.3-0.5-1.4-1.1 c-2.7-8.1-9.2-15.1-17.9-19.5v-9.5c0-0.6-0.3-1.3-1-1.4c-0.6-0.3-1.3-0.2-1.8,0.3l-7.2,7.1c-1.4-0.3-3.1-0.6-4.5-0.8 c-0.8-0.2-1.6,0.5-1.8,1.3c-1.8,10-10.5,17.3-20.8,17.3c-5.3,0-10.3-1.9-14.2-5.4c-0.3-0.3-0.8-0.5-1.1-0.5 c-0.5,0-0.8,0.2-1.1,0.5c-4.7,5.4-7.2,11.6-7.7,18.1c-0.6-0.2-1.4-0.5-1.9-1.1c-0.8-0.8-1.3-2.1-1.3-3.7v-6.3c0,0,0,0,0-0.2 c0-0.2,0-2.1,1.1-3.5c0.8-0.6,2.1-1.1,3.7-1.1c1,0,1.6-0.6,1.6-1.6c0-1-0.6-1.6-1.6-1.6c-2.6,0-4.5,0.8-6,2.2 C0,36.2,0,39.2,0,39.7V46c0,2.5,0.8,4.4,2.3,5.9c1.3,1.3,3.1,1.7,4.2,1.9c0.3,6.7,3.1,13.2,7.9,18.6l-1.4,4.9 c-0.2,0.6,0,1.1,0.5,1.6l6.4,6.3c0.6,0.6,1.6,0.6,2.3,0l4.2-4.1c6.3,3,13.2,4.6,20.4,4.6s14.2-1.6,20.4-4.6l4.2,4.1 c0.3,0.3,0.8,0.5,1.1,0.5c0.3,0,0.8-0.2,1.1-0.5l6.4-6.3c0.5-0.5,0.6-1,0.5-1.6l-1.6-4.9c3.1-3.3,5.1-7,6.6-11 c0.2-0.6,0.8-1.1,1.4-1.1h1.6c2.7,0,4.8-2.1,4.8-4.8v-6.3C93.3,46.5,91.2,44.4,88.5,44.4z M90.1,55.5c0,1-0.6,1.6-1.6,1.6h-1.6 c-2.1,0-3.9,1.3-4.5,3.2c-1.3,3.8-3.5,7.3-6.4,10.5c-0.3,0.5-0.5,1-0.3,1.6l1.4,4.9l-4.7,4.6l-3.9-3.8c-0.5-0.5-1.3-0.6-1.9-0.3 c-6,3.2-12.9,4.8-20,4.8s-14-1.6-20-4.8c-0.2-0.2-0.5-0.2-0.8-0.2c-0.5,0-0.8,0.2-1.1,0.5l-3.9,3.8l-4.7-4.6l1.4-4.9 c0.2-0.5,0-1.1-0.3-1.6c-5-5.2-7.7-11.6-7.7-18.4c0-5.9,2.1-11.4,6-16.3c4.3,3.3,9.5,5.2,15,5.2c11.3,0,20.9-7.6,23.5-18.4 c1.3,0.2,2.4,0.5,3.5,0.8c0.5,0.2,1.1,0,1.6-0.5l5.1-5.1v6.8c0,0.6,0.3,1.1,1,1.4c8.4,4,14.5,10.5,17.1,18.1 c0.6,1.9,2.4,3.2,4.5,3.2h1.6c1,0,1.6,0.6,1.6,1.6V55.5L90.1,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000103261013205195257500000005946836315867660989_",
    className: "st1",
    d: "M52,51.3l-6.4,6.3c-0.6,0.6-0.6,1.6,0,2.2 c0.3,0.3,0.8,0.5,1.1,0.5c0.3,0,0.8-0.2,1.1-0.5l6.4-6.3c0.6-0.6,0.6-1.6,0-2.2C53.6,50.6,52.6,50.6,52,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000011751465780943668660000002382046670333922460_",
    className: "st1",
    d: "M52,44.9L39.1,57.6c-0.6,0.6-0.6,1.6,0,2.2 c0.3,0.3,0.8,0.5,1.1,0.5c0.3,0,0.8-0.2,1.1-0.5l12.9-12.7c0.6-0.6,0.6-1.6,0-2.2C53.6,44.3,52.6,44.3,52,44.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000006682700403753690200000008688261567325868418_",
    className: "st1",
    d: "M40.2,54c0.5,0,0.8-0.2,1.1-0.5l6.4-6.3 c0.6-0.6,0.6-1.6,0-2.2c-0.6-0.6-1.6-0.6-2.3,0l-6.4,6.3c-0.6,0.6-0.6,1.6,0,2.2C39.4,53.8,39.7,54,40.2,54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000034776782795281643100000014878188474723182757_",
    className: "st1",
    d: "M30.6,28.6c6.3,0,11.3-4.9,11.3-11.1 c0-1-0.6-1.6-1.6-1.6s-1.6,0.6-1.6,1.6c0,4.4-3.5,7.9-8,7.9c-1,0-1.6,0.6-1.6,1.6S29.6,28.6,30.6,28.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBankIcon);
export default __webpack_public_path__ + "static/media/piggy_bank_icon.b562886c2fb1f1a4a6512e3782d7f930.svg";
export { ForwardRef as ReactComponent };